<template>
  <a-card :bordered="false" title="会员卡" :headStyle="{borderBottom:'0px',fontSize:'18px'}">
    <search-page-view
      :col="4"
      ref="pageList"
      :itemNames="searchItemList"
      :columns="columns"
      :queryParams="queryParams"
      row-key="id"
      :leftSpace="10"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="search_cardName" label="名称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.name" allow-clear placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="search_money" label="面额" v-bind="searchItemLayout">
        <a-input v-model.number="queryParams.denomination" allow-clear :maxLength="4" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="search_source" label="状态" v-bind="searchItemLayout">
        <a-select
          style="width: 100%"
          v-model="queryParams.status"
          placeholder="请选择" allowClear
        >
          <a-select-option value="1">未开始</a-select-option>
          <a-select-option value="2">发行中</a-select-option>
          <a-select-option value="3">已结束</a-select-option>
        </a-select>
      </a-form-item>
      <a-row slot="operation" style="margin-bottom: 15px;">
        <a-col :span="8">
          <a-button type="primary" icon="plus" @click="newMemberCard(0,1)">新建</a-button>
        </a-col>
        <a-col :span="8" :offset="8" style="text-align: right;">设置实体卡购买新卡页面 &nbsp;<a
          @click="openVisible">设置</a></a-col>
      </a-row>
      <span slot="avatarUrl" slot-scope="rowItem">
        <CustomImage width="60" :imageUrl="rowItem.record.image"></CustomImage>
      </span>
      <span slot="action" slot-scope="rowItem">
        <a v-if="rowItem.record.status==1" @click="newMemberCard(rowItem.record.id,rowItem.record.status)">编辑信息</a>
        <a v-else @click="newMemberCard(rowItem.record.id,rowItem.record.status)">查看详情</a>
        <span>
          <a-divider type="vertical"/>
          <a @click="goEletron(rowItem.record)">销售数据</a>
        </span>
        <span>
          <a-divider type="vertical"/>
          <a @click="showChannel(rowItem.record)">核销渠道</a>
        </span>
        <span>
          <a-divider type="vertical"/>
          <a @click="goCardTransactionDetail(rowItem.record)">交易明细</a>
        </span>
      </span>
    </search-page-view>
    <a-modal title="设置实体卡购买链接"
             :visible="visible"
             @ok="handleOk"
             :confirmLoading="confirmLoading"
             @cancel="visible = false"
    >
      <a-textarea v-model="linkUrl" placeholder="请输入链接，推荐使用专题链接,需要以https://或http://开头"
                  :auto-size="{ minRows: 2, maxRows: 6 }"
      />
    </a-modal>
    <a-modal
      title="核销渠道"
      :visible="channelVisible"
      @cancel="channelVisible = false"
      @ok="handleSubmit"
      width="900px"
    >
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                    :label-col="currentDialogLayout.labelCol"
                    :wrapper-col="currentDialogLayout.wrapperCol"
      >
        <a-form-model-item label="核销渠道">
          <a-radio-group v-model="ruleForm.writeOffChannel" @change="onChangeRadio">
            <a-radio :value="3">全部店铺</a-radio>
            <a-radio :value="1">官方店可用</a-radio>
            <a-radio :value="2">全部分销店可用</a-radio>
            <a-radio :value="4">官方店和指定分销员店铺</a-radio>
            <a-radio :value="5">指定分销员店铺</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <div v-if="ruleForm.writeOffChannel>3">
          <a-form-model-item label="指定分销员店铺" prop="staffIds">
            <div>
              <a-button type="priamry" @click="onShowShopDialog">选择店铺</a-button>
            </div>
            <div>
              <a-tag
                v-for="(item,index) in ruleForm.staffIds"
                :closable="true"
                color="blue"
                @close="handleStaffClose(item.staffId)"
                :key="item.staffId">
                {{ item.shopName }}
              </a-tag>
            </div>
          </a-form-model-item>
        </div>
      </a-form-model>
    </a-modal>
    <selected-product-dialog
      title='选择指定分销员店铺'
      :show="showSelectedDialog"
      ref="pageDialogList"
      row-key="staffId"
      :rowSelection="{ selectedRowKeys: selectedGroupRowKeys, onChange: onShopChange }"
      :requestPromise="getMemberListPromise"
      @close="onCloseShopDialog"
      :columns="getColumns()"
      :itemNames="['search_staffName','search_shopName']"
      :query-params="selectedQueryParams"
      extraPaginationName="extraPaginationName"
      :customPagination="true"
    >
      <a-form-item
        label="姓名"
        slot="search_staffName" v-bind="currentDialogLayout2">
        <a-input
          v-model="selectedQueryParams.staffName"
          style="width: 170px"
          placeholder="请输入姓名"
        ></a-input>
      </a-form-item>
      <a-form-item
        label="店铺名称"
        slot="search_shopName"
        v-bind="currentDialogLayout2">
        <a-input
          v-model="selectedQueryParams.staffShopName"
          style="width: 170px"
          placeholder="请输入商品名称"
        ></a-input>
      </a-form-item>
      <template slot="extraPaginationName" v-if='selectedGroupRowKeys&&selectedGroupRowKeys.length>0'>
        <a-button type="primary" @click="onCheckAll">确定</a-button>
      </template>
      <span slot="memberState" slot-scope="rowItem">
          <template v-if="rowItem.record.staffAudit===1">
              <span>{{ rowItem.record.staffStatus|staffStatusName }}</span>
          </template>
          <template v-else>{{ rowItem.record.staffAudit|staffAuditName }}</template>
        </span>
    </selected-product-dialog>
  </a-card>
</template>

<script>
import searchForm from '../../../utils/mixins/searchFormMixins'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'
import moment from 'moment'

export default {
  name: 'MemberLists',
  mixins: [searchForm],
  components: {
    SelectedProductDialog
  },
  data() {
    return {
      searchItemList: ['search_cardName', 'search_money', 'search_source'],
      queryParams: {},
      loadPromise: params => this.getListPromise(params),
      linkUrl: '',
      visible: false,
      confirmLoading: false,
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          width: '100px'
        },
        {
          title: '会员卡名称',
          dataIndex: 'name',
          width: '102px'
        },
        {
          title: '卡面图片',
          dataIndex: 'image',
          scopedSlots: { customRender: 'avatarUrl' },
          width: '100px'
        },
        {
          title: '面额(元)',
          align: 'center',
          dataIndex: 'denomination',
          width: '240px'
        },
        {
          title: '发行量',
          dataIndex: 'releaseShow',
          width: '160px'
        },
        {
          title: '有效期',
          dataIndex: 'validityShow',
          width: '160px'
        },
        {
          title: '状态',
          dataIndex: 'statusStr',
          width: '80px'
        },
        {
          title: '卡类型',
          dataIndex: 'cardTypeSTr',
          width: '80px'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '160px'
        },
        {
          title: '审核状态',
          width: '88px',
          align: 'center',
          dataIndex: 'auditStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '310px',
          align: 'center',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      channelVisible: false,
      currentDialogLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 }
      },
      currentDialogLayout2: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      ruleForm: {
        writeOffChannel: 1,
        staffIds: [],
        id: undefined
      },
      rules: {
        staffIds: [
          { required: true, message: '请选择指定分销员店铺', trigger: 'change' }
        ]
      },
      selectedQueryParams: {
        searchName: '',
        proId: ''
      },
      showSelectedDialog: false,
      selectedGroupRowKeys: [],
      selectedRows: []
    }
  },
  mounted() {
  },
  activated() {
    if (this.$route.query.updateFlag) {
      this.getLogUtils().logWithTag('activated', this.$route.query.updateFlag)
      this.$refs.pageList.refresh(true)
    }
  },
  methods: {
    handleStaffClose(removedTag) {
      this.ruleForm.staffIds = this.ruleForm.staffIds.filter(tag => tag.staffId !== removedTag)
    },
    onShopChange(selectedRowKeys, selectedRows) {
      this.selectedGroupRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    onChangeRadio(e) {
      if (e.target.value > 3) {
        this.ruleForm.staffIds = []
      }
    },
    onCheckAll() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.error('请选择店铺')
        return false
      }
      let firstArr = []
      let secondArr = []
      this.selectedRows.forEach(item => {
        firstArr.push({
          staffId: item.staffId,
          shopName: item.staffShopName
        })
      })
      if (this.ruleForm.staffIds && this.ruleForm.staffIds.length > 0) {
        this.ruleForm.staffIds.forEach(item => {
          secondArr.push({
            staffId: item.staffId,
            shopName: item.shopName
          })
        })
      }
      let arr = firstArr.concat(secondArr)

      this.ruleForm.staffIds = this.unique(arr)
      this.onCloseShopDialog()
    },
    unique(arr) {
      let map = new Map()
      for (let item of arr) {
        if (!map.has(item.staffId)) {
          map.set(item.staffId, item)
        }
      }
      return [...map.values()]
    },
    onCloseShopDialog() {
      this.showSelectedDialog = false
    },
    onShowShopDialog() {
      this.selectedGroupRowKeys = []
      this.selectedRows = []
      this.showSelectedDialog = true
    },
    showChannel(record) {
      this.channelVisible = true
      this.ruleForm.id = record.id
      this.getCardInfo(record.id)
    },
    getCardInfo(id) {
      this.getHttpServices().getUserService().post('member/v2/card/getMembershipCardDetail', {
        membershipCardId: id
      }).then(res => {
        this.ruleForm.writeOffChannel = res.writeOffChannel
        this.ruleForm.staffIds = res.staffIds
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getMemberListPromise(params) {
      params.staffStatus = 1
      return this.getHttpServices().getUserService().post('staff/v2/getStaffList', params)
    },
    getColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'staffId'
        },
        {
          title: '店铺名称',
          dataIndex: 'staffShopName'
        },
        {
          title: '姓名',
          dataIndex: 'staffName'
        },
        {
          title: '状态',
          dataIndex: 'memberState',
          scopedSlots: { customRender: 'memberState' }
        }
      ]
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitData() {
      let params = this.ruleForm
      this.getHttpServices().getUserService().post('member/v2/card/updateWriteOffChannel', params)
        .then(res => {
          this.$message.success('编辑成功')
          this.channelVisible = false
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //新建+编辑+查看
    newMemberCard(cardId, status) {
      this.$router.push({
        name: 'NewMemberCard',
        query: {
          cardId: cardId,
          status: status
        }
      })
    },
    goCardTransactionDetail(record) {
      let query = {
        cardId: record.id
      }
      this.openNewPage('MemberCardTransactionDetail', query)
    },
    goEletron(data) {
      let name = ''
      if (data.cardType == 1) {
        name = 'ElectronCardList'
      } else {
        name = 'EntityCardList'
      }
      this.$router.push({
        name,
        query: { cardId: data.id, cardName: data.name }
      })
      // this.$router.push({
      //   name: "EntityCardList",
      //   query:{cardId:cardId}
      // })
    },
    getListPromise(params) {
      return this.getHttpServices().getUserService().post('member/v2/card/getMembershipCardList', params)
    },
    handleOk() {
      if (this.checkForm()) {
        this.confirmLoading = true
        this.getHttpServices().getUserService().post('member/v2/card/saveEntityCardBuyLink', {
          buyEntityLink: this.linkUrl
        }).then(res => {
          this.$message.success('设置实体卡购买链接成功')
          this.visible = false
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.confirmLoading = false)
      }
    },
    checkForm() {
      let url = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/
      if (!this.linkUrl) {
        this.$message.error('请设置实体卡购买链接')
        return false
      }
      if (this.linkUrl) {
        if (!url.test(this.linkUrl)) {
          this.$message.error('实体卡购买链接有误')
          return false
        }
      }
      return true
    },
    openVisible() {
      this.visible = true
      this.getHttpServices().getUserService().post('member/v2/card/getEntityCardBuyLink').then(res => {
        this.getLogUtils().logWithTag('openVisible==', res)
        if (res && res.buyEntityLink) {
          this.linkUrl = res.buyEntityLink
        } else {
          this.linkUrl = ''
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>

<style scoped>
.head-picture {
  width: 50px;
  height: 50px;
  border-radius: 4px;
  border: none;
}
</style>
